export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["खोज"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आप डेमो मोड में हैं। शेष राशि और लेनदेन प्रशिक्षण के लिए हैं।"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कार्य कैबिनेट में जाएं"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["कुछ नहीं मिला"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["डैशबोर्ड"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["मेरे स्टोर"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["जानकारी"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["नया स्टोर"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सूचना"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["संचालन इतिहास"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["सहायता"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रतिपक्ष जानकारी"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML जाँच"])}
}